<template>
  <div class="member-indoor-item-filter">
    <div class="title-row">
      <h3 class="title" v-t="'appMemberUserFilter.search'" />
      <a
        class="clear"
        v-t="'appMemberUserFilter.action.clear'"
        v-on:click="$_clear"
      />
    </div>
    <input-keyword
      v-model="localKeyword"
      v-bind:placeholder="$t('appMemberIndoorItem.placeholder.keyword')"
      v-on:search="$_onSearchKeyword"
    />
    <indoor-site-and-building-selector
      id-prefix="member-indoor-item"
      v-bind:indoor-site-ids="localCondition.indoorSiteIds"
      v-bind:indoor-building-ids="localCondition.indoorBuildingIds"
      v-on:selected="$_onSiteBuildingSelected"
    />
  </div>
</template>

<script>
import IndoorSiteAndBuildingSelector from '@/components/indoor/AppIndoorSiteAndBuildingSelector.vue'

export default {
  name: 'AppMemberIndoorItemFilter',
  components: {
    IndoorSiteAndBuildingSelector,
  },
  inheritAttrs: false,
  props: {
    /**
     * キーワード
     */
    keyword: {
      type: String,
      default: null,
    },
    /**
     * サイトID
     */
    indoorSiteIds: {
      type: Array,
      default: null,
    },
    /**
     * ビルID
     */
    indoorBuildingIds: {
      type: Array,
      default: null,
    },
  },
  data: function () {
    return {
      // ローカル保持用絞り込み条件
      localCondition: {
        keyword: null,
        indoorSiteIds: null,
        indoorBuildingIds: null,
      },
      // 内部用キーワード(リアクティブ化を避けるため分離）
      localKeyword: null,
    }
  },
  watch: {
    keyword: {
      immediate: true,
      handler: function (value) {
        this.localKeyword = value
      },
    },
    indoorSiteIds: {
      immediate: true,
      handler: function (value) {
        this.localCondition.indoorSiteIds = value
      },
    },
    indoorBuildingIds: {
      immediate: true,
      handler: function (value) {
        this.localCondition.indoorBuildingIds = value
      },
    },
    localCondition: function () {
      this.$_emitConditionChangedEvent()
    },
  },
  methods: {
    /**
     * 条件クリア
     */
    $_clear: function () {
      this.localCondition = {
        keyword: null,
        indoorSiteIds: null,
        indoorBuildingIds: null,
      }
      this.localKeyword = null
    },

    /**
     * キーワード検索実行時処理
     * @param {String} value 入力値
     */
    $_onSearchKeyword: function (value) {
      this.localCondition = {
        ...this.localCondition,
        keyword: value,
      }
    },

    /**
     * サイト・ビル選択変更時処理
     * @param {Object} value 選択値
     */
    $_onSiteBuildingSelected: function (value) {
      if (value) {
        this.localCondition = {
          indoorSiteIds: value.indoorSiteId,
          indoorBuildingIds: value.indoorBuildingId,
          keyword: this.localKeyword,
        }
      } else {
        this.localCondition = {
          indoorSiteIds: null,
          indoorBuildingIds: null,
          keyword: this.localKeyword,
        }
      }
    },

    /**
     * 条件変更イベント発行
     */
    $_emitConditionChangedEvent: function () {
      /**
       * 条件変更イベント
       * @param {Object} condition 条件
       */
      this.$emit('condition-changed', this.localCondition)
    },
  },
}
</script>

<style lang="scss" scoped>
.member-indoor-item-filter {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  row-gap: 8px;
}

.title-row {
  width: 100%;
  padding: 0 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 1;

  .title {
    font-size: $font-size-middle;
    font-weight: $font-weight-bold;
    margin: 0;
  }

  .clear {
    font-size: $font-size-middle;
    color: $text-color-link;
    text-decoration: $text-color-link underline;

    &:hover {
      cursor: pointer;
    }
  }
}

::v-deep .input-keyword {
  width: 100%;
}
</style>
